<template>
  <section id="contact" class="contact">
    <div class="contact-container">
      <div class="section-header">
        <h2 class="section-title">Get In Touch</h2>
        <p class="section-subtitle">Let's work together on your next project</p>
      </div>
      
      <div class="contact-content">
        <div class="contact-info">
          <h3>Let's connect and discuss opportunities</h3>
          <p>
            I'm always interested in new opportunities and exciting projects.
            Feel free to reach out to me directly through LinkedIn or email - I'd love to hear from you!
          </p>
          
          <div class="contact-details">
            <div class="contact-item clickable" onclick="window.open('mailto:mauryaajaykumar99@gmail.com', '_blank')">
              <i class="fas fa-envelope"></i>
              <div>
                <h4>Email Me</h4>
                <p>mauryaajaykumar99@gmail.com</p>
                <small>Click to send email</small>
              </div>
            </div>
            
            <div class="contact-item clickable" onclick="window.open('https://www.linkedin.com/in/ajaykumar-maurya/', '_blank')">
              <i class="fab fa-linkedin"></i>
              <div>
                <h4>LinkedIn</h4>
                <p>Connect with me professionally</p>
                <small>Click to view profile</small>
              </div>
            </div>
            
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <div>
                <h4>Location</h4>
                <p>Mumbai, India</p>
              </div>
            </div>
          </div>
          
          
          <div class="social-links">
            <div class="social-icons">
              <a href="https://www.linkedin.com/in/ajaykumar-maurya/" target="_blank" class="social-link">
                <i class="fab fa-linkedin"></i>
              </a>
              <a href="https://github.com/Ajayku2grt" target="_blank" class="social-link">
                <i class="fab fa-github"></i>
              </a>
              <a href="https://x.com/AJAYKUM12552073" target="_blank" class="social-link">
                <i class="fab fa-twitter"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactSection'
}
</script>

<style scoped>
.contact {
  padding: 5rem 0;
  background: white;
}

.contact-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.section-header {
  text-align: center;
  margin-bottom: 4rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.1rem;
  color: #7f8c8d;
  max-width: 600px;
  margin: 0 auto;
}

.contact-content {
  display: flex;
  justify-content: center;
}

.contact-info {
  max-width: 700px;
  text-align: center;
}

.contact-info h3 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 1rem;
}

.contact-info > p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  margin-bottom: 2rem;
}

.contact-details {
  margin-bottom: 3rem;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  text-align: left;
}

.contact-item.clickable {
  cursor: pointer;
  padding: 1rem;
  border-radius: 12px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.contact-item.clickable:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.contact-item i {
  font-size: 1.5rem;
  color: #3498db;
  width: 30px;
}

.contact-item h4 {
  font-size: 1.1rem;
  color: #2c3e50;
  margin: 0 0 0.3rem 0;
}

.contact-item p {
  color: #7f8c8d;
  margin: 0;
}

.contact-item small {
  color: #95a5a6;
  font-size: 0.9rem;
  display: block;
  margin-top: 0.2rem;
}

.contact-cta {
  background: #f8f9fa;
  padding: 2.5rem;
  border-radius: 15px;
  margin: 3rem 0;
}

.contact-cta h4 {
  color: #2c3e50;
  font-size: 1.3rem;
  margin-bottom: 1rem;
}

.contact-cta p {
  color: #7f8c8d;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.cta-btn {
  padding: 15px 25px;
  border-radius: 10px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  min-width: 180px;
  justify-content: center;
}

.cta-btn.primary {
  background: #0077b5;
  color: white;
}

.cta-btn.primary:hover {
  background: #005885;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 119, 181, 0.3);
}

.cta-btn.secondary {
  background: #3498db;
  color: white;
}

.cta-btn.secondary:hover {
  background: #2980b9;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(52, 152, 219, 0.3);
}

.social-links h4 {
  color: #2c3e50;
  margin-bottom: 1rem;
}

.social-icons {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  background: #f8f9fa;
  color: #2c3e50;
  text-decoration: none;
  border-radius: 50%;
  font-size: 1.2rem;
  transition: all 0.3s ease;
}

.social-link:hover {
  background: #3498db;
  color: white;
  transform: translateY(-3px);
}



/* Responsive */
@media (max-width: 768px) {
  .contact-info {
    max-width: 100%;
    padding: 0 1rem;
  }
  
  .section-title {
    font-size: 2rem;
  }
  
  .contact-cta {
    padding: 2rem;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-btn {
    min-width: 200px;
  }
  
  .contact-item.clickable {
    padding: 0.8rem;
  }
}
</style>
